import React, { useContext, useEffect } from "react";
import { AddUserDataContext } from "context/AddUserContext";
import { TicketApi } from "services/ticket";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { Circle } from "sub_components/Common/Circle";
import styled from "styled-components";
import { DATACENTER_LOCATIONS } from "utils/CommonConstants";
const CDN_URL = process.env.REACT_APP_CDN_URL;
const badgeImage = `${CDN_URL}profile/icon-badge.svg`;
const DCAccessStyle = styled.div`
.data-center-screen-locations{
	height: 160px;
}
.ScrollbarsCustom-Track {
	right: -10px !important;
	top: 0px !important;
}
.ScrollbarsCustom-ThumbY {
	background-color: ${(props) => props.theme.account} !important;
	width: 6px !important;
}
.ScrollbarsCustom-TrackY:before {
	border-left: none;
}
.ScrollbarsCustom-TrackY {
	background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
	box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
		1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
	width: 6px !important;
}
	.locations-wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		.location {
			width: 65px;
			height: 65px;
			cursor: pointer;
			position: relative;
			margin-right: 17px;
			margin-left: 17px;
			margin-bottom: 20px;
			display: flex;
			flex-direction: column;
            justify-content:center;
            align-items:center;
			.location-title {
				white-space:nowrap;
			}
			.badge-icon{
				position:absolute;
				right:10px ;
				bottom:30px;
				//border:1px solid blue;
				width:10px;
					height:10px;
				img{
					
					width:20px;
					height:20px;
				
				}
			}
			&.access{
				img{
					width:10px;
					height:10px;
					top: 16px;
					left: 27px;
				}
			}
			.location-icon {
				position: absolute;
				top: 8px;
				left: 20px;
				width: 25px;
				height: 25px;
				border:none;
			}
			&.active {
				opacity: 1;
					circle {
						fill: #ffffff;
					}
			}
		}
	}

	@media screen and (min-width: ${(props) =>
    props.theme.res.medium}) and (max-width: ${(props) =>
  props.theme.res.high}) {

		.data-center-screen-locations{
			height: 200px;
		}

		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${(props) => props.theme.account} !important;
			width: 8px !important;
		}
		.locations-wrapper {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
	
			.location {
				width: 75px;
				height: 75px;
				cursor: pointer;
				position: relative;
				margin-right: 30px;
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				justify:content;center;
				align-items:center;
				.location-title {
				}
				&.access{
					img{
						width:20px;
						height:20px;
						top: 17px;
						left: 27px;
						
					}
				}
				.location-icon {
					position: absolute;
					top: 12px;
					left: 22px;
					width: 30px;
					height: 30px;
					border:none;
				}
				&.active {
					opacity: 1;
						circle {
							fill: #ffffff;
						}
				}
			}
		}
	}
	@media screen and (min-width: ${(props) => props.theme.res.high}) {
		.data-center-screen-locations{
			height: 350px;
		}

		.ScrollbarsCustom-Track {
			right: -10px !important;
		}
		.ScrollbarsCustom-ThumbY {
			background-color: ${(props) => props.theme.account} !important;
			width: 10px !important;
		}
		.locations-wrapper {
			
	
			.location {
				width: 125px;
				height: 125px;
				margin-right: 40px;
				margin-bottom: 40px;

				&.access{
					img{
						width:25px;
						height:25px;
						top: 37px;
						left: 48px;	
					}
				}
				
				.location-icon {
					position: absolute;
					top: 28px;
					left: 43px;
					width: 40px;
					height: 40px;
					border:none;
				}
				&.active {
					opacity: 1;
						circle {
							fill: #ffffff;
						}
				}
			}
		}
	}
`;

let locations = [
  { location: "No Access", key: "access", tag: "" },
  ...DATACENTER_LOCATIONS,
];

function isSelected(location, selectedLocations) {
  if (!selectedLocations) {
    return false;
  }

  if (selectedLocations.includes(location?.location)) {
    return true;
  } else {
    return false;
  }
}

export const DCAccessScreen = ({ type, organizationServices }) => {
  const { inputs, change } = useContext(AddUserDataContext);

  useEffect(() => {
    const hasLocations = inputs.hasLocations;
    if (hasLocations.length !== 0) {
      for (let i = 0; i <= hasLocations.length - 1; i++) {
        locations = locations.map((location) => {
          let updatedLocation = location;
          if (
            location.tag === hasLocations[i]?.datacenter &&
            !hasLocations[i]?.escort_required
          ) {
            updatedLocation = { ...location, badge: true };
          }
          return updatedLocation;
        });

        change({ target: { name: "locations", value: inputs?.locations } });
      }
    } else {
      locations = [
        { location: "No Access", key: "access", tag: "access" },
        ...DATACENTER_LOCATIONS,
      ];
      change({ target: { name: "locations", value: [] } });
    }
    if (type === "BADGE_REQUEST") {
      locations = locations.filter(
        (location) => location.location !== "No Access"
      );
    }
  }, [inputs?.hasLocations, inputs.name]);

  function updateLocations(location) {
    let value = location;
    const locations = inputs?.locations;
    let selected = [];
    if (locations && locations.length !== 0) {
      selected = locations.filter((location) => location === value);
    }

    if (selected.length === 0) {
      if (value === "No Access") {
        value = [value];
      } else {
        value = checkLocationAcccess(location, locations);
      }
    } else if (selected.length !== 0) {
      value = locations.filter((location) => location !== value);
    }

    change({ target: { name: "locations", value } });
    change({ target: { name: "badgeAccess", value: "" } });
  }
  function hasAccess(locationTag) {
    if (!organizationServices) {
      return true;
    }
    if (locationTag === "access") {
      return true;
    } else {
      const serviceWithAccess = organizationServices.find(
        (service) =>
          (service.name.toLowerCase() === "network" ||
            service.name.toLowerCase() === "colo") &&
          service?.datacenterName.toLowerCase() === locationTag.toLowerCase()
      );

      return !!serviceWithAccess;
    }
  }

  function checkLocationAcccess(location, locations) {
    let value = location;

    if (!locations.includes("No Access") || value !== "No Access") {
      if (locations.includes("No Access") && value !== "No Access") {
        const removeNoAccess = locations.filter(
          (location) => location !== "No Access"
        );
        value = [...removeNoAccess, value];
      } else {
        value = [...locations, value];
      }
    }
    return value;
  }

  return (
    <DCAccessStyle>
      <div className="data-center-screen-locations">
        <ScrollView>
          <div className="locations-wrapper">
            {locations.map(
              (location) =>
                hasAccess(location?.tag) && (
                  <div
                    id={location.key}
                    className={
                      isSelected(location, inputs?.locations)
                        ? `location ${location.key} active`
                        : `location ${location.key}`
                    }
                    onClick={() => updateLocations(location?.location)}
                    data-cy={`location-${location.tag}`}
                  >
                    <Circle location={location.location} />
                    <img
                      className="location-icon"
                      src={TicketApi.getSmallBuildingIcons(location.location)}
                    />
                    <div className="location-title body10">
                      {location?.location}
                    </div>
                    {location?.badge && (
                      <div className="badge-icon">
                        <img src={badgeImage} />
                      </div>
                    )}
                  </div>
                )
            )}
          </div>
        </ScrollView>
        {locations.length === 0 && (
          <div className="body10">User has access to all data centers.</div>
        )}
      </div>
    </DCAccessStyle>
  );
};
